import React, {useState, useEffect, useContext, useRef} from 'react';
import clsx from 'clsx';
import {AppContext} from '../../contexts/AppContext';
import {getDetailPageUrl} from '../../helpers/accommodation';
import {translate} from '../../helpers/base';

const SearchField = () => {
    const {selectedFilters, handleSearchQueryChange} = useContext(AppContext);

    const [query, setQuery] = useState(selectedFilters.q || '');
    const [options, setOptions] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const debounceTimeout = useRef(null);
    const inputRef = useRef(null);
    const endpoint = window._config.typeaheadEndpoint;

    useEffect(() => {
        if (query.length > 2) {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
            debounceTimeout.current = setTimeout(() => {
                fetch(`${endpoint}?query=${query}`)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            setOptions(data.data.options);
                        }
                    });
            }, 300); // 300ms debounce time
        } else {
            setOptions([]);
        }

        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    // reset on empty search query
    useEffect(() => {
        if(!selectedFilters.q) {
            setQuery('');
            setOptions([]);
            setShowDropdown(false);
        }
    }, [selectedFilters]);

    const handleInputChange = (e) => {
        setQuery(e.target.value);
        setShowDropdown(true);
    };

    const handleOptionClick = (option) => {
        if (option.link) {
            window.location = getDetailPageUrl(option.link, selectedFilters);
            return;
        } else {
            updateFilter(option);
        }
        setQuery(option.label);
        setShowDropdown(false);
    };

    const updateFilter = (option) => {
        setShowDropdown(false);
        handleSearchQueryChange(option);
    };

    return (
        <div className={clsx('typeahead-input', (showDropdown && options.length > 0) && 'has-dropdown')}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 26">
                <path
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="m25 24.2-7.699-7.618m2.47-6.285c0 5.134-4.202 9.297-9.386 9.297C5.202 19.594 1 15.43 1 10.297 1 5.162 5.202 1 10.385 1c5.184 0 9.386 4.162 9.386 9.297Z"
                ></path>
            </svg>
            <input
                type="text"
                name="q"
                className="search"
                aria-label="Suchbegriff"
                placeholder={translate('accommodation-overview.searchField.placeholder')}
                autoComplete="off"
                value={query}
                ref={inputRef}
                onChange={handleInputChange}
                onFocus={() => {
                    setShowDropdown(true);
                    inputRef.current.select();
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && options.length > 0) {
                        handleOptionClick(options[0]);
                    }
                }}
            />
            {/*{query && <button className="clear-button" onClick={clearInput}>x</button>}*/}
            {showDropdown && options.length > 0 && (
                <ul className="dropdown">
                    {options.map((option, index) => (
                        <li key={index} onClick={() => handleOptionClick(option)}>
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SearchField;
